// API endpoints — mapped 1:1 to the real talos (AWS Lambda) production endpoints,
// see oee-frontend/config/prod-env-config.js for the source of truth this was mapped against.
export const apiRoutes = {
    plants: {
        getAll: '/listPlants',
        getProductionLine: '/listProductionLines',
        update: '/UpdatePlant',
        create: '/createPlant'
    },
    kpis: {
        stats: '/getStats',
        mergeList: '/mergeStatsList',
        // TODO: no talos backend for this yet — no ListAlerts Lambda exists in talos
        alerts: '/alerts/list?conditions=',
        list:'/listStats',
        generateStats:'/generateStatsForTime'
    },
    logs: {
        downtimes: '/listDowntimeLogs',
        disconnect: '/listDisconnectLogs',
        updateDisconnect: '/UpdateDisconnectLog',
        updateDowntime: '/UpdateDowntimeLog',
        mergeDowntime: '/mergeOrDemergeDowntimeLog',
        splitDowntime: '/mergeOrDemergeDowntimeLog',
    },
    roles: {
        list: '/listRoles',
        create: '/createRole',
        update: '/UpdateRole',
        delete: '/deleteRole',
        get:'/getRoles'
    },
    plantSettings: {
        addUser: '/accountCreationAlert',
        updateAccessControl: '/AccessControlUpdate'
    },
    forceStop: {
        email: '/emailOnStopShift',
        updateLine: '/UpdateProductionLine',
        updateStats: '/UpdateStats',
        createLog: '/createLogs'
    },
    alerts: {
        create: '/createLogs'
    },
    shifts: {
        // TODO: no talos backend for this yet — no shift-create Lambda exists in talos
        create: '/shifts/create'
    },
    dynamicAdjustments: {
        list: '/listDynamicAdjustments',
        create: '/createDynamicAdjustments'
    },
    productionLine:{
        update:'/UpdateProductionLine',
        product:'/getProducts',
        create: '/createProductionLine',
        createMachine:'/createMachine',
        createPlannedDowntime:'/createPlannedDowntimes'
    },
    emailOn: {
        rejection: '/emailOnRejection',
        rework: '/emailOnRework'
    },
    auditTrails: {
        generateReport: '/listLogs'
    }
}


// {%22_id%22:%22drops_iphf9-8:15-20:15-2023-05-19%22,%22lineId%22:%22drops_iphf9%22,%22plantId%22:%22korangi_4c1lf%22}

// {%22_id%22:%22drops_iphf9-08:15-13:15-2023-05-19%22,%22lineId%22:%22drops_iphf9%22,%22plantId%22:%22korangi_4c1lf%22}
